import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSimpleForm } from '../services/simpleForm/service';
import { EncryptedObjectIdString } from '../types/common';
import { SimpleFormDto } from '../types/dto/simpleForm';
import { withSimpleFormApiErrorHandling } from '../utils/simpleForm/handleSimpleFormApiError';
import { usePublicResource } from './useResource';

const simpleFormByEncryptedIdMap = new Map<
    EncryptedObjectIdString,
    SimpleFormDto
>();

export const useSimpleForm = () => {
    const navigate = useNavigate();
    const { fetchResource } = usePublicResource<
        {
            encryptedSimpleFormId: EncryptedObjectIdString;
        },
        SimpleFormDto
    >({
        fetchFn: getSimpleForm,
        cacheMap: simpleFormByEncryptedIdMap,
        getCacheKey: ({ encryptedSimpleFormId }) => encryptedSimpleFormId,
    });

    const fetchSimpleForm = useCallback(
        (params: { encryptedSimpleFormId: EncryptedObjectIdString }) =>
            withSimpleFormApiErrorHandling(
                () => fetchResource(params),
                navigate,
            ),
        [fetchResource, navigate],
    );

    return { fetchSimpleForm };
};
